import React from 'react';
import { Image } from 'semantic-ui-react';
import Card from '@material-ui/core/Card';
import AppServer from '../../../functions/servername';
import $ from "jquery";
import Buttons from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

class ViewAll extends React.Component {

    state = {
        part: [], related: [], partcodeOption: [], combos: []
    }

    componentDidMount() {
        this.getSpareDetails(this.props.sparesDetailsPartno, this.props.sparesDetailsItem)
    }

    componentDidUpdate(props) {
        if (props.sparesDetailsPartno != this.props.sparesDetailsPartno) {
            this.getSpareDetails(this.props.sparesDetailsPartno, this.props.sparesDetailsItem)
        }
    }

    getSpareDetails(partno, item) {
        let context = this;
        context.setState({ load: true, message: 'Getting Spares Info!!!' })
        $.ajax({
            type: 'POST', data: { partno },
            url: AppServer() + 'ui/getpartinfo.php',
            success: function(data) {
                let part = [];
                let images = [];
                let related = [];
                let combos = [];
                try {
                    data = JSON.parse(data);
                    let related = data.related;
                    combos = context.combos(partno);
                    related = context.removeDuplicates(related);
                    context.setState({ load: false, combos, part: data.part, related: related, images: data.images, item })
                } catch (error) {
                    context.setState({ load: false })
                }
            },
            error: function(err) {
                context.setState({ load: false })
                alert('Try again!!!!')
            }
        });
    }

    combos(partno) {
        let combosTitle = [];
        let modelsAndCombos = this.props.modelsAndCombos;
        modelsAndCombos = modelsAndCombos.combos;
        modelsAndCombos.map((c) => {
            if (c.partno == partno) {
                combosTitle.push({ title: c.combo_name })
            }
        })
        return combosTitle;
    }

    removeDuplicates(originalArray) {
        var newArray = [];
        originalArray = originalArray.slice().reverse();
        var lookupObject  = {};
        for(var i in originalArray) {
           lookupObject[originalArray[i]['partno']] = originalArray[i];
        }
        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    addItem(item) {
        let shoppingListContainer = this.refs.scrolldiv;
        if (shoppingListContainer) {
        shoppingListContainer.style.scrollWidth =
            shoppingListContainer.style.scrollHeight;
        }
        let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");
        if (!customerDualScreenorderList) {
            customerDualScreenorderList = "[]";
        }
        try {
            customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
            if (!customerDualScreenorderList) {
                customerDualScreenorderList = [];
            }
            let refId = 0;
            let value = 0;
            customerDualScreenorderList.map((v) => {
                if (v.partno == item.partno) {
                    value = 1;
                    v.qty = v.qty + 1;
                    v.quantity = v.quantity + 1;
                }
                else { 
                    refId = v.refId;
                }
            })
            refId = refId + 1;
            if (value == 0) {
                customerDualScreenorderList.push({ 
                    'partno': item.partno, 'discountrs': 0,
                    'spare_name': item.title, 'partname': item.title, 'discountper': 0, 'point': 0, 'ava_stocks': 0, 
                    'qty': 1, 'refId': refId, 'brand': 1, 'remarks': 'remarks',
                    'tax': item.tax, 'discount': 0, 'quantity': 1, checked: false,
                    'billtype': 'Invoice', 'mrp': item.mrp, 'uprice': item.mrp, 
                })
            }
            customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
            localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
            this.props.refreshData();
            this.setState({ customerDualScreenorderList })
        } catch (error) {
        }
    }

    selectedSpares(partno, item) {
        this.props.detailsSparesPage(partno, item);
    }

    viewCombo(combo) {
        this.props.viewComboScreen(combo);
    }

    render() {
        return (
            <div class="mobileview">
                <Image refs="scrolldiv" src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+this.props.sparesDetailsItem.partno+".jpg"} 
                    style={{width: '100%', height: 400}} />
                    { this.state.combos.length > 0 ?
                        (
                            <div style={{margin: '2.5%'}}>
                                <h4>Combos</h4>
                                <Grid container spacing={2}>
                                    { 
                                        this.state.combos.map((c) => {
                                            return (
                                                <Grid item xs={3}>
                                                    <Paper style={{cursor: 'pointer'}} onClick={this.viewCombo.bind(this, c.title)}>
                                                        <h3 style={{padding: '3%'}}>{c.title}</h3>
                                                    </Paper>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </div>
                        ):''
                    }
                    <div style={{margin: '2%'}}>
                        <h4>Highlights</h4>
                        <div style={{borderColor: 'black', borderStyle: 'solid', borderWidth: '1px', padding: '1%', borderRadius: '3px'}}>
                            <b>Description</b>
                            <div>{this.props.sparesDetailsItem.description}</div>
                            <br/>
                            <b>Feature And Details</b>
                            <div>
                                <div style={{display: 'flex', width: '100%'}}>
                                    <div style={{width: '30%'}}><b>Tamil Name</b></div>
                                    <div style={{width: '70%'}}>{this.props.sparesDetailsItem.tamil_name}</div>
                                </div>

                                <div style={{display: 'flex', width: '100%'}}>
                                    <div style={{width: '30%'}}><b>Local Name</b></div>
                                    <div style={{width: '70%'}}>{this.props.sparesDetailsItem.local_name}</div>
                                </div>

                                <div style={{display: 'flex', width: '100%'}}>
                                    <div style={{width: '30%'}}><b>Part Number</b></div>
                                    <div style={{width: '70%'}}>{this.props.sparesDetailsItem.partno}</div>
                                </div>

                                <div style={{display: 'flex', width: '100%'}}>
                                    <div style={{width: '30%'}}><b>Machine Support</b></div>
                                    <div style={{width: '70%'}}>{this.state.part.from_serialno+' - '+this.state.part.to_serialno}</div>
                                </div>

                                <div style={{display: 'flex', width: '100%'}}>
                                    <div style={{width: '30%'}}><b>Weight of the product</b></div>
                                    <div style={{width: '70%'}}>{this.state.part.weight+' Kg(s)'}</div>
                                </div>
                            </div>
                        </div>
                        <Buttons  onClick={this.addItem.bind(this, this.props.sparesDetailsItem)} 
                            style={{marginTop: '1%', marginBottom: '1%'}} color='primary' 
                            variant='outlined' fullWidth>ADD</Buttons>
                    </div>
                    <h4>Related Products</h4>
                    <Grid container>
                        {
                            this.state.related.map((c) => {
                                return (
                                    <Grid item xs={4}>
                                        <Paper onClick={this.selectedSpares.bind(this, this.props.sparesDetailsItem.partno, c)}>
                                            <div style={{cursor: 'pointer'}}>
                                                <Image src={"https://s3.ap-south-1.amazonaws.com/vaigaiclaas.com/feature/"+c.partno+".jpg"} 
                                                style={{width: '97%', height: '200px', borderRadius: '5px', margin: '3px'}} />
                                            </div>
                                            <div style={{padding: '5px', cursor: 'pointer'}} >
                                                <b style={{fontSize: '13px'}}>{c.title}</b><br/>
                                                <b style={{fontSize: '13px'}}>{c.partno}</b>
                                            </div>
                                            <div>
                                                <Buttons onClick={this.addItem.bind(this, c)} 
                                                    style={{margin: '5%', width: '90%'}} 
                                                    color='primary' variant='outlined'>
                                                    ADD
                                                </Buttons>
                                            </div>
                                        </Paper>
                                    </Grid>
                                )
                                
                            })
                        }
                    </Grid>
            </div>
        );
    }
}

export default ViewAll;
